/** Split tasting course lines: optional `Gang 01–03 · Name — note`. */
export function splitTastingCourseLabel(line: string): {
  step: string;
  name: string;
  note: string;
} {
  let rest = line.trim();
  let step = '';
  const stepSep = rest.indexOf(' · ');
  if (stepSep !== -1) {
    const candidate = rest.slice(0, stepSep).trim();
    if (/^(Gang|Course|Bước)\b/i.test(candidate)) {
      step = candidate;
      rest = rest.slice(stepSep + 3).trim();
    }
  }
  const sep = rest.indexOf(' — ');
  if (sep === -1) {
    return { step, name: rest, note: '' };
  }
  return {
    step,
    name: rest.slice(0, sep).trim(),
    note: rest.slice(sep + 3).trim(),
  };
}
